/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { AVM1Object } from "../runtime/AVM1Object";
import { wrapAVM1NativeMembers } from "./AVM1Utils";
var AVM1Stage = /** @class */ (function (_super) {
    __extends(AVM1Stage, _super);
    function AVM1Stage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Stage.createAVM1Class = function (context) {
        var wrapped = new AVM1Stage(context);
        wrapAVM1NativeMembers(context, wrapped, AVM1Stage.prototype, ['align#', 'displayState#', 'fullScreenSourceRect#', 'height#',
            'scaleMode#', 'showMenu#', 'width#'], false);
        return wrapped;
    };
    AVM1Stage.bindStage = function (context, cls, stage, htmlElement) {
        cls._awayAVMStage = stage;
        AVM1Stage.stage = stage;
    };
    AVM1Stage.prototype.getAlign = function () { return this._awayAVMStage.align; };
    AVM1Stage.prototype.setAlign = function (value) { this._awayAVMStage.align = value; };
    AVM1Stage.prototype.getDisplayState = function () { return this._awayAVMStage.displayState; };
    AVM1Stage.prototype.setDisplayState = function (value) { this._awayAVMStage.displayState = value; };
    AVM1Stage.prototype.getFullScreenSourceRect = function () { return this._awayAVMStage.fullScreenSourceRect; };
    AVM1Stage.prototype.setFullScreenSourceRect = function (value) { this._awayAVMStage.fullScreenSourceRect = value; };
    AVM1Stage.prototype.getHeight = function () { return this._awayAVMStage.stageHeight; };
    AVM1Stage.prototype.getScaleMode = function () { return this._awayAVMStage.scaleMode; };
    AVM1Stage.prototype.setScaleMode = function (value) { this._awayAVMStage.scaleMode = value; };
    AVM1Stage.prototype.getShowMenu = function () { return this._awayAVMStage.showDefaultContextMenu; };
    AVM1Stage.prototype.setShowMenu = function (value) { this._awayAVMStage.showDefaultContextMenu = value; };
    AVM1Stage.prototype.getWidth = function () { return this._awayAVMStage.stageWidth; };
    return AVM1Stage;
}(AVM1Object));
export { AVM1Stage };
